export default __webpack_public_path__ + "static/media/tuxedo1.c6ff8253.jpg";